var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSceneActive)?_c('div',{ref:"sceneContainer",staticClass:"scene-container"},[_vm._t("default")],2):_c('div',{staticClass:"domain-error"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }